"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loggedOutSaveRedirect = exports.unsaveEvent = exports.saveEvent = void 0;

var _cookiesJs = _interopRequireDefault(require("cookies-js"));

var _http = require("js-utils/http");

var _urlLib = require("url-lib");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saveEventUrl = '/api/v3/destination/save/';
var unsaveEventUrl = '/api/v3/destination/unsave/';

var _saveOrUnsaveEvent = function _saveOrUnsaveEvent(url, eventId) {
  return (0, _http.sdkRequest)(url, {
    method: 'POST',
    body: JSON.stringify({
      event_ids: ["".concat(eventId)]
    })
  });
};

var saveEvent = function saveEvent(eventId) {
  return _saveOrUnsaveEvent(saveEventUrl, eventId);
};

exports.saveEvent = saveEvent;

var unsaveEvent = function unsaveEvent(eventId) {
  return _saveOrUnsaveEvent(unsaveEventUrl, eventId);
};

exports.unsaveEvent = unsaveEvent;

var loggedOutSaveRedirect = function loggedOutSaveRedirect(eventId, _ref) {
  var pathname = _ref.pathname,
      query = _ref.query;

  // save the cookie with organizer information
  _cookiesJs.default.set(_constants.EVENT_COOKIE, eventId, {
    path: pathname,
    secure: true,
    expires: 300
  }); // then redirect to signin page


  (0, _http.setWindowLocation)((0, _urlLib.formatUrl)('/signin/', {
    referrer: (0, _urlLib.formatUrl)(pathname, query)
  }));
  return Promise.resolve();
};

exports.loggedOutSaveRedirect = loggedOutSaveRedirect;
//# sourceMappingURL=api.js.map